import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { Breadcrumbs } from '@/components/layout/breadcrumbs.tsx'
import { AttributeGroup } from '@/features/attribute-groups/types.ts'
import { AttributeGroupForm } from '@/routes/_authenticated/settings/attribute-groups/-components/form.tsx'

export const Route = createFileRoute(
  '/_authenticated/settings/attribute-groups/create/'
)({
  component: AttributeGroupCreate,
})

function AttributeGroupCreate() {
  const navigate = useNavigate()
  const handleSubmitted = (attributeGroup: AttributeGroup) => {
    navigate({
      to: '/settings/attribute-groups/edit/$attributeGroupId',
      params: { attributeGroupId: attributeGroup.id },
    })
  }

  return (
    <>
      <Breadcrumbs
        items={[
          { name: 'Impostazioni' },
          {
            name: 'Gruppi Attributi',
            to: `/settings/attribute-groups`,
          },
          {
            name: 'Nuovo',
          },
        ]}
      />

      <AttributeGroupForm onSubmitted={handleSubmitted} />
    </>
  )
}
